module.exports = __webpack_public_path__ + "img/horizontal_stacked_bar_chart.a32edbd4.svg";